import { useMutation } from "@tanstack/react-query";
import { updateGameNameAssistant } from "../api/updateGameNameAssistant";

export const useUpdateGameNameAssistantMutation = () => {
  return useMutation({
    mutationFn: async (params: {
      languageName: string;
      assistantId: string;
    }) => {
      const response = await updateGameNameAssistant(
        params.languageName,
        params.assistantId,
      );
      return response;
    },
  });
};
